module.exports = __webpack_public_path__ + "static/media/StancastingBackground.e1964908.png";